import React from 'react'
import PbAtendimentoFormPageContainer from './PbAtendimentoFormPageContainer'

export class PbAtendimentoFormPage extends React.Component {
  render() {
    return <PbAtendimentoFormPageContainer {...this.props} />
  }
}
